import React from "react";
import { Container } from 'reactstrap';

const GOLD = "#6a2dec";

const Footer = () => {
    return (
        <React.Fragment>
            <footer className="footer">
                <Container fluid>
                    <div className="d-flex align-items-center justify-content-between flex-wrap gap-2" style={{ width: "100%", minHeight: 40 }}>
                        <div className="d-flex align-items-center gap-2" style={{ whiteSpace: "nowrap" }}>
                            <img
                                src="/logo.png"
                                alt="Oplena"
                                width={24}
                                height={24}
                                style={{ objectFit: "contain" }}
                            />
                            <span style={{ fontSize: 14, fontWeight: 700, letterSpacing: "-0.3px", color: "#ffffff" }}>
                                Oplena
                            </span>
                            <span style={{ fontSize: 13, color: "rgba(255,255,255,0.55)" }}>
                                © {new Date().getFullYear()} — Todos os direitos reservados
                            </span>
                        </div>
                        <div className="d-none d-md-block" style={{ fontSize: 13, color: "rgba(255,255,255,0.55)", whiteSpace: "nowrap" }}>
                            Grupo Oplena
                        </div>
                    </div>
                </Container>
            </footer>
        </React.Fragment>
    );
};

export default Footer;
